// @flow
import React, {PureComponent} from 'react';
import {FormattedMessage} from 'react-intl';
import {Switch} from '@homeaway/react-form-components';
import {INSTANT_BOOK_FILTER_ID} from '../../constants/filters';
import InstantBookIcon from '../InstantBookIcon/InstantBookIcon';
import type {IntlShape} from 'react-intl';

import './InstantConfirmationFilter.less';

export type Props = {
    id: string,
    intl: IntlShape,
    handleChecked: (event: SyntheticEvent<HTMLInputElement>) => any,
    checked: boolean,
    className: string
};

class InstantConfirmationFilter extends PureComponent<Props> {
    render() {
        const {id, handleChecked, checked, className, intl} = this.props;
        return (
            <div
                role="menuitem"
                className={`InstantConfirmationFilter ${className}`}
                data-wdio="InstantConfirmationFilter"
            >
                <div className="InstantConfirmationFilter--row form-group">
                    <div className="InstantConfirmation__primaryLabel">
                        <InstantBookIcon intl={intl} />
                        <span id={`instant_confirmation_label-${className}`}>
                            <FormattedMessage
                                defaultMessage="Instant Confirmation"
                                description="toggle instant confirmation properties"
                                id="instantConfirmationPrimaryLabel"
                            />
                        </span>
                    </div>
                    <div className="InstantConfirmation__secondaryLabel">
                        <FormattedMessage
                            defaultMessage="Book without waiting for owner approval"
                            description="information label for instant confirmation"
                            id="instantConfirmationSecondaryLabel"
                        />
                    </div>
                </div>
                <div
                    className="InstantConfirmationFilter--row form-group"
                    data-wdio="InstantConfirmationFilter__toggle"
                >
                    <Switch
                        id={id}
                        name={INSTANT_BOOK_FILTER_ID}
                        checked={checked}
                        onChange={handleChecked}
                        aria-labelledby={`instant_confirmation_label-${className}`}
                    />
                </div>
            </div>
        );
    }
}

export default InstantConfirmationFilter;
